/**
 * Canonical advanced-filter store/query keys aligned with the Housien API.
 */
export const PROPERTY_FILTER_KEYS = {
  acceptsPets: 'accepts_pets',
} as const;

/**
 * Convert a qty chip selection (e.g. "3" or "5+") to a store-ready integer.
 * Returns undefined when no chip is selected.
 */
export function qtyChipToStoreValue(
  chip: string | undefined,
): number | undefined {
  if (!chip) return undefined;
  const cleaned = chip.replace('+', '');
  const num = parseInt(cleaned, 10);
  return Number.isNaN(num) ? undefined : num;
}
